import {AfterViewInit, Component, Input, ViewChild} from "@angular/core";
import {ICellRendererAngularComp} from 'ag-grid-angular';

@Component({ standalone: false,
  selector: "irb-number-text-box-cell",
  template: `<irb-number-text-box #numberTextBox
                    [value]="params.value"
                    (applyChange)="onChange($event)"
                    [min]="min"
                    [max]="max"
                    [isCurrency]="isCurrency"
                    [isPercentage]="isPercentage"
                    [isNegative]="isNegative"
                    [isBold]="isBold"
                    [isNotApplicable]="isNotApplicable"
                    [disabled]="disabled"
                    [invalidMessage]="invalidMessage"
                    [invalidRangeMessage]="invalidRangeMessage"
                    [places]="places"
                    [displayPlaces]="displayPlaces"
                    [addZeroIfDotFirst]="addZeroIfDotFirst"
                    [editIconOnHover]="editIconOnHover"
                    width="100%"
                    [class]="autoHeight ? 'auto-height' : ''"></irb-number-text-box>`
})
export class NumberTextBoxRendererComponent implements ICellRendererAngularComp, AfterViewInit {
    params: any;
    cbFunc: Function;
    originalValue: any;
    places: number;
    displayPlaces: number;
    min: number;
    max: number;
    isCurrency: boolean;
    isNegative: boolean;
    isPercentage: boolean;
    isBold: boolean;
    isNotApplicable: boolean;
    disabled: boolean;
    invalidMessage: string;
    invalidRangeMessage: string;
    autofocus: boolean;
    autoSelect: boolean;
    autoHeight: boolean;
    addZeroIfDotFirst: boolean;
    editIconOnHover: boolean = false;

    @ViewChild('numberTextBox') numberTextBox: any;

    agInit(params: any): void {
        this.params = params;
        this.params.value = (this.params.value !== null) ? parseFloat(this.params.value) : this.params.value;
        this.originalValue = this.params.value;
        this.cbFunc = this.params.onUpdate || null;
        this.min = (this.params.min === 0) ? 0 : this.params.min || null;
        this.max = (this.params.max === 0) ? 0 : this.params.max || null;
        this.isCurrency = (typeof this.params.isCurrency !== "undefined") ? this.params.isCurrency : false;
        this.isPercentage = (typeof this.params.isPercentage !== "undefined") ? this.params.isPercentage : false;
        this.isNegative = (typeof this.params.isNegative !== "undefined") ? this.params.isNegative : false;
        this.isBold = (typeof this.params.isBold !== "undefined") ? this.params.isBold : false;
        this.isNotApplicable = (typeof this.params.isNotApplicable !== "undefined") ? this.params.isNotApplicable : false;
        this.disabled = (typeof this.params.disabled !== "undefined") ? this.params.disabled : false;
        this.invalidMessage = this.params.invalidMessage || "Invalid input";
        this.invalidRangeMessage = this.params.invalidRangeMessage || "Invalid range";
        this.places = this.params.places || 0;
        this.displayPlaces = this.params.displayPlaces || this.places;
        this.autofocus = this.params.autofocus || false;
        this.autoSelect = this.params.autoSelect || false;
        this.autoHeight = this.params.autoHeight || false;
        this.addZeroIfDotFirst = this.params.addZeroIfDotFirst || false;
        this.editIconOnHover = this.params.editIconOnHover || false;
    }

    refresh(): boolean {
        return true;
    }

    onChange(v: any): void {
        if (this.params.onChange) {
            this.params.onChange(this.params, v);
        }
    }

    ngAfterViewInit(): void {
        if (this.autofocus && !this.disabled) {
            setTimeout(() => {
                if (this.params) {
                    const rowIndex = this.params.rowIndex || this.params.node.rowIndex;
                    this.params.api.setFocusedCell(rowIndex, this.params.column);
                    this.numberTextBox.inputField.nativeElement.focus();
                }
            }, 150);
        }
    }
}
